import { useContext } from 'react';

/**
 * Fetch a given context or throw an error if it is null or undefined.
 * @param context Context to use.
 * @param message Message to throw if context is null or undefined.
 * @returns Context, or throws
 */
export function useContextOrThrow(context) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'No value available in context. Was code wrapped in a provider?';
  var value = useContext(context);
  if (value == null) {
    throw new Error(message);
  }
  return value;
}
export default useContextOrThrow;
//# sourceMappingURL=useContextOrThrow.js.map